import React, { useMemo } from "react";
import { Badge, IconButton, Tooltip } from "@mui/material";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { useTranslation } from "react-i18next";
import { appColors } from "../../../constants/theme";

/**
 * Navbar bildirim ikonu — drawer yerine üst barda.
 */
const CustomMessageMenuButton = ({
  handleClickMessageMenu,
  openMessageMenu,
  unreadCount = 0,
}) => {
  const { t } = useTranslation();

  const badgeContent = useMemo(
    () => (unreadCount > 99 ? "99+" : unreadCount),
    [unreadCount]
  );

  return (
    <Tooltip title={t("notifications")}>
      <IconButton
        onClick={handleClickMessageMenu}
        aria-controls={openMessageMenu ? "message-notifications" : undefined}
        aria-haspopup="true"
        aria-expanded={openMessageMenu ? "true" : undefined}
        aria-label={t("notifications")}
        size="medium"
        sx={{
          color: appColors.gray900,
          p: { xs: 0.75, md: 1 },
        }}
      >
        <Badge
          badgeContent={badgeContent}
          color="error"
          overlap="circular"
          invisible={!unreadCount}
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "0.65rem",
              minWidth: 16,
              height: 16,
            },
          }}
        >
          <NotificationsNoneOutlinedIcon sx={{ fontSize: { xs: 22, md: 24 } }} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default CustomMessageMenuButton;
